/**
 * #### Decisyon Srl ####
 * Author 		: Pagano Francesco
 * Date 		: 01.12.2015 
 * Description 	: This service is responsible for:
						1) Check the config object for the past meets the interface for the correct construction of the preset menu choice;
						2) Return the object merged config of options passed to the proper construction of the menu.
 */

(function() {
	'use strict';

	var DcyMenuOptionsService = function(dcyMenuTypesConstants) {

		var TYPES_MENU = dcyMenuTypesConstants(),
			InterfaceDcyMenu = function (menuType, objects, methods) {
				this.type 		= menuType;
				this.objects	= [];
				this.methods 	= [];
	
				var pushValues = function(arrToRead, arrToPush){
					for (var i = 0, len = arrToRead.length; i < len; i++) {
						if (typeof arrToRead[i] !== 'string') {
							throw new Error ("dcyMenuOptionsService : InterfaceDcyMenu constructor expects method names to be " + "passed in as a string.");
						}
	
						arrToPush.push(arrToRead[i]);
					}
				};
	
				pushValues(methods , this.methods );
				pushValues(objects , this.objects );
			},
			//Check that the interface configuration pass is valid for instantiating the selected menu
			ensureDcyMenuImplements = function (config, menuInterface) {
				_.forEach(menuInterface, function(values, mainKey) {
					if(_.isObject(values)){
						var checkTypeFn = angular.equals(mainKey, 'objects') ? _.isObject : angular.isFunction; 
						_.forEach(values, function(prop, propKey) {
							if (!config[mainKey][prop] || !checkTypeFn(config[mainKey][prop])) {
								throw new Error ('dcyMenuOptionsService : This Class does not implement the interface correctly. The property \'' + prop + '\' not valid.Expected ["+mainKey+"] type.');
							}
						});
					}
				});
			},
	
			//Return the options for menu
			getMenuOptsByType = function (menuType){
				var menuOpts;
				switch (menuType) {
				case TYPES_MENU.MENU_GENERIC.type:
					menuOpts = TYPES_MENU.MENU_GENERIC;
					break;
	
				default:
					break;
				}
				return menuOpts;
			},	
			//Returns the interface that must be respected
			getDcyMenuInterface = function(type){
				var menuInterface;
				switch (type) {
				case TYPES_MENU.MENU_GENERIC.type:
					menuInterface = new InterfaceDcyMenu(TYPES_MENU.MENU_GENERIC.type, ['data', 'targetInfo'], ['clickItem', 'isItemEnabled', 'indentIcon']);
					break;
	
				default:
					throw new Error ('dcyMenuOptionsService : Menu Type ['+type+'] not supported.');
				break;
				}
				return menuInterface;
			};
			
		//Init the interface and return config object
		this.initMenuInterface = function(config){
			ensureDcyMenuImplements(config, getDcyMenuInterface(config.type));
			return angular.merge(getMenuOptsByType(config.type), config);
		};
	};

	DcyMenuOptionsService.$inject = ['dcyMenuTypesConstants'];
	angular.module('dcyApp').register.service('dcyMenuOptionsService', DcyMenuOptionsService);

}());